import React, { useState, useEffect } from "react";
import {
  Button,
  Select,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import { useSearchParams, useNavigate } from "react-router-dom";
import client from "../../../../helpers/Client";

export default function ProjectFilterBar() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "");
  const [filterType, setFilterType] = useState(searchParams.get("kind") || "");
  const [city, setCity] = useState(searchParams.get("city") || "");
  const [cities, setCities] = useState([]);

  const bgColor = "white";
  const borderColor = "gray.200";
  const textColor = "gray.700";

  useEffect(() => {
    setSearchTerm(searchParams.get("search") || "");
    setFilterType(searchParams.get("kind") || "");

    const cityParam = searchParams.get("city");
    // Only set city if it's numeric, otherwise ignore (it was likely an invalid param)
    if (cityParam && !isNaN(Number(cityParam))) {
      setCity(cityParam);
    } else {
      setCity("");
    }
  }, [searchParams]);

  useEffect(() => {
    client.get("/public/cities/")
      .then(resp => setCities(resp.data.results || resp.data))
      .catch(err => console.error("Could not fetch cities", err));
  }, []);

  const handleSearch = () => {
    const params = new URLSearchParams(searchParams);

    if (searchTerm) params.set("search", searchTerm);
    else params.delete("search");

    if (filterType) params.set("kind", filterType);
    else params.delete("kind");

    if (city) params.set("city", city);
    else params.delete("city");

    // Reset pagination to 1 when filtering
    params.set("page", "1");

    setSearchParams(params);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Stack direction={{ base: "column", md: "row" }} spacing={3} w="full" bg="gray.50" p={4} borderRadius="xl" border="1px solid" borderColor="gray.200">
      <InputGroup size="md" flex={1}>
        <InputLeftElement pointerEvents="none">
          <Icon as={FiSearch} color="gray.400" />
        </InputLeftElement>
        <Input
          placeholder="Proje ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          bg={bgColor}
          border="1px"
          borderColor={borderColor}
          color={textColor}
          _placeholder={{ color: "gray.400" }}
          borderRadius="lg"
        />
      </InputGroup>

      <Select
        placeholder="Şehir Seçiniz"
        value={city}
        onChange={(e) => setCity(e.target.value)}
        bg={bgColor}
        border="1px"
        borderColor={borderColor}
        color={textColor}
        maxW={{ base: "full", md: "200px" }}
        borderRadius="lg"
      >
        {cities.map(c => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </Select>

      <Select
        placeholder="Tür filtrele"
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
        bg={bgColor}
        border="1px"
        borderColor={borderColor}
        color={textColor}
        maxW={{ base: "full", md: "200px" }}
        borderRadius="lg"
      >
        <option value="collective">Toplu Konut</option>
        <option value="villa">Villa</option>
        <option value="factory">Fabrika</option>
        <option value="office">Ofis</option>
        <option value="bs_center">İş Merkezi</option>
        <option value="sp_center">AVM</option>
        <option value="pl_bldng">Kamu Binası</option>
        <option value="hotel">Otel</option>
        <option value="eatery">Restoran/Kafe</option>
        <option value="other">Diğer</option>
      </Select>

      <Button
        colorScheme="blue"
        onClick={handleSearch}
        borderRadius="lg"
        px={8}
      >
        Filtrele
      </Button>
    </Stack>
  );
}